// Campus photo for /colleges/georgia-state-university: CC BY-SA 4.0, by Jayingram11, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AGeorgia_State_University_College_of_Law_Building.jpeg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/georgia-state-university/; credited under the photo.
const photo = {
    "slug": "georgia-state-university",
    "alt": "The Georgia State University College of Law building on Park Place in downtown Atlanta",
    "src": "/colleges/georgia-state-university/campus-1600.webp",
    "srcSmall": "/colleges/georgia-state-university/campus-800.webp",
    "srcMid": "/colleges/georgia-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/georgia-state-university/og.jpg",
    "title": "Georgia State University College of Law Building",
    "author": "Jayingram11",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AGeorgia_State_University_College_of_Law_Building.jpeg",
    "read": "2026-09-30"
};

export default photo;
